module.exports = __webpack_public_path__ + "img/logo4.ada971c6.png";